import { render, staticRenderFns } from "./WorkflowDetails.vue?vue&type=template&id=c4547efe&scoped=true"
import script from "./WorkflowDetails.vue?vue&type=script&lang=js"
export * from "./WorkflowDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDetails.vue?vue&type=style&index=0&id=c4547efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4547efe",
  null
  
)

export default component.exports